import { post, get, geted } from '../network/index.js'

//团购订单详情 - 券码延期
const delayCode = data => {
  return post('/webi/webOnlineOrder/delayCode', data)
}
// 修改团单地址
const updateGroupAddress = data => {
  return post('/webi/webOnlineOrder/updateAddressByOrder', data)
}

//商家后台 --> 修改地址
const modifySubscribeMen = data => {
  return post('/mercWebi/subscribeOrder/modifySubscribeMen', data)
}

//商家后台 --> 指派家政员
const addWorker = data => {
  return post('/mercWebi/subscribeOrder/appointHomemaking', data)
}
//商家后台 --> 移除家政员
const deleteHomemaking = data => {
  return post('/mercWebi/subscribeOrder/deleteHomemaking', data)
}
//商家后台 --> 获取适用的家政员列表
const listApplyHomemaking = data => {
  return post('/mercWebi/subscribeOrder/listApplyHomemaking', data)
}
//商家后台 --> 家政员设为组长
const modifyHomemakingPosition = data => {
  return post('/mercWebi/subscribeOrder/modifyHomemakingPosition', data)
}
//商家后台 --> 作废订单
const obsoleteSubscribeOrder = data => {
  return post('/mercWebi/subscribeOrder/obsoleteSubscribeOrder', data)
}
//商家后台 --> 商家后台发起家政订单已结算（分三种结算方式：1、商家结算；2、家政员结算；3、定时任务结算）
const settleSubscribeOrder = data => {
  return post('/mercWebi/subscribeOrder/settleSubscribeOrder', data)
}

// 家政状态订单
const countSubscribeOrder = data => {
  return post('/mercWebi/subscribeOrder/countSubscribeOrder', data)
}
//家政订单管理 - 订单列表
const listSubscribeOrder = data => {
  return post('/mercWebi/subscribeOrder/listSubscribeOrder', data)
}
// 查询家政订单详情
const listSubscribeOrderById = data => {
  return post('/mercWebi/subscribeOrder/listSubscribeOrderById', data)
}
// 设置家政订单
const modifySubscribeMode = data => {
  return post('/mercWebi/subscribeOrder/modifySubscribeMode', data)
}
//  商家后台发起补款记录
const addedFillingRecord = data => {
  return post('/mercWebi/subscribeOrder/addedFillingRecord', data)
}
//商家后台 - 售后服务
const aftermarketSubscribeOrder = data => {
  return post('/mercWebi/subscribeOrder/aftermarketSubscribeOrder', data)
}

// 商家后台 - 查询家政订单劵码使用信息
const listCodeRelBySubscribeId = data => {
  return post('/mercWebi/subscribeOrder/listCodeRelBySubscribeId', data)
}
// 商家后台 - 导出家政订单列表
const downloadSubscribeOrder = data => {
  return post('/mercWebi/subscribeOrder/downloadSubscribeOrder', data)
}
// 商家后台 - 查看报表列表
const listDownloadManager = data => {
  return post('/mercWebi/downloadManager/listDownloadManager', data)
}
// 商家后台 - 重新下载
const handDownload = data => {
  return post('/mercWebi/downloadManager/handDownload', data)
}
// 商家后台 - 修改总计时
const modifyRealityServiceTime = data => {
  return post('/mercWebi/subscribeOrder/modifyRealityServiceTime', data)
}
// 商家后台 - 取消补款记录
const cancelFillingRecord = data => {
  return post('/mercWebi/subscribeOrder/cancelFillingRecord', data)
}
// 商家后台 - 校验小程序第三方平台家政预约
const checkTrilateralOrder = data => {
  return post('/mercWebi/subscribeOrder/checkTrilateralOrder', data)
}
// 商家后台 --> 新增家政订单备注
const insertOrderRemarke = data => {
  return post('/mercWebi/subscribeOrder/insertOrderRemarke', data)
}
// 商家后台 --> 修改家政订单备注
const modifyOrderRemarke = data => {
  return post('/mercWebi/subscribeOrder/modifyOrderRemarke', data)
}
// 商家后台 --> 删除家政订单备注
const deleteOrderRemarke = data => {
  return post('/mercWebi/subscribeOrder/deleteOrderRemarke', data)
}

// 礼券订单列表
const couponOrderList = data => {
  return post('/mercWebi/order/couponOrderList', data)
}

// 抖音订单取消
const dyOrderCancel = data => {
  return post('/mercWebi/dy/order/cancelOrder', data)
}

// 抖音订单核销
const dyOrderVerify = data => {
  return post('/mercWebi/dy/order/verify', data)
}

// 抖音订单完成
const dyOrderFinfish = data => {
  return post('/mercWebi/dy/order/finfish', data)
}

// 抖音订单详情
const getDyOrderDetail = data => {
  return post('/mercWebi/dy/order/detail', data)
}

// 快递结算卡
const getExpressCardList = data => {
  return geted('/mercWebi/express/settle-card-list', data)
}

// 快递结算卡
const expressOrderPickup = data => {
  return post('/express/order-pickup', data)
}

// 商品订单-送达
const goodsOrderArrive = data => {
  return post('/mercWebi/dy/order/arrive', data)
}

// 商品订单-到店取单
const goodsOrderArrived = data => {
  return post('/mercWebi/dy/order/arrived', data)
}

// 商品订单-配送完成
const goodsOrderCompleted = data => {
  return post('/mercWebi/dy/order/completed', data)
}

// 商品订单-已备单
const goodsOrderPrepared = data => {
  return post('/mercWebi/dy/order/prepared', data)
}

// 商品订单-配送中
const goodsOrderProgress = data => {
  return post('/mercWebi/dy/order/progress', data)
}

// 团购-洗护订单-取消
const cancelGroupWashOrder = data => {
  return post('/mercWebi/order/cancelWashOrder', data)
}

// 团购-家政订单-取消
const cancelGroupSubscribeOrder = data => {
  return post('/mercWebi/subscribeOrder/cancelOrder', data)
}

// 洗护订单-发起补款
const addWashOrderPayment = data => {
  return post('/mercWebi/washOrder/addPayment', data)
}
// 洗护订单-取消补款
const cancelWashOrderPayment = data => {
  return post('/mercWebi/washOrder/cancelAddPayment', data)
}

export default {
  delayCode,
  updateGroupAddress,
  addWorker,
  countSubscribeOrder,
  listSubscribeOrder,
  listSubscribeOrderById,
  modifySubscribeMode,
  addedFillingRecord,
  listApplyHomemaking,
  modifyHomemakingPosition,
  modifySubscribeMen,
  obsoleteSubscribeOrder,
  deleteHomemaking,
  settleSubscribeOrder,
  aftermarketSubscribeOrder,
  listCodeRelBySubscribeId,
  downloadSubscribeOrder,
  listDownloadManager,
  handDownload,
  modifyRealityServiceTime,
  cancelFillingRecord,
  checkTrilateralOrder,
  insertOrderRemarke,
  modifyOrderRemarke,
  deleteOrderRemarke,
  couponOrderList,
  dyOrderCancel,
  dyOrderVerify,
  dyOrderFinfish,
  getDyOrderDetail,
  getExpressCardList,
  expressOrderPickup,
  goodsOrderArrive,
  goodsOrderArrived,
  goodsOrderCompleted,
  goodsOrderPrepared,
  goodsOrderProgress,
  cancelGroupWashOrder,
  cancelGroupSubscribeOrder,
  addWashOrderPayment,
  cancelWashOrderPayment
}
